'use client';
import React from 'react';

export interface LabelProps {
  label?: string;
  required?: boolean;
  styles?: React.CSSProperties;
}

export const Label = ({ required, label, styles }: LabelProps) => {
  if (!label) {
    return null;
  }

  return (
    <label className="text-base font-medium text-darkBlue">
      {required && <span className="text-red-500">*</span>}
      <span className="text-[14px]" style={styles}>
        {label}
      </span>
    </label>
  );
};

export default Label;
